// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3a8ka","gfeWrapper":"CalendarEvent_gfeWrapper__3eWm_"};